import SendFormDialog from './SendFormDialog.view';

export default SendFormDialog;
